import { ArchiveIcon } from '@ui/icons';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { issuesActions } from '@sonar-software/sonar-issues';
import { useAction } from '@hooks';
import React, { useCallback } from 'react';

export interface ArchiveIssueButtonProps {
    sonarObjectId: number;
}

export const ArchiveIssueButton: React.FC<ArchiveIssueButtonProps> = ({ sonarObjectId }) => {
	const archiveOrSnoozeIssue = useAction(issuesActions.requestPostIssuesByIdVisibility);

	const handleArchiveClick = useCallback((e: React.MouseEvent) => {
		e.stopPropagation();

		archiveOrSnoozeIssue({
			archive: true,
			sonarObjectId
		});
	}, [ archiveOrSnoozeIssue, sonarObjectId ]);

	return (
		<Button
			icon={ <ArchiveIcon /> }
			id={ `archive-issue-${sonarObjectId}` }
			onClick={ handleArchiveClick }
			type='default'>{ COPY_SPECIFIC.ARCHIVE }
		</Button>
	);
};
